import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CLEAR_PROPS_FOR_QUOTATION,
  CREATE_TPWQ_SUCCESS,
  FETCH_TPW_NO_SUCCESS,
  FETCH_TPWQ_SUCCESS,
  GET_TPWQ_SUCCESS,
  SAVE_TPWQ_QUERY,
  STORE_TOTAL_DATA_FOR_LABOUR,
  STORE_TOTAL_DATA_FOR_SPARE,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchFilter, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";

export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_TPWQ_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_TPWQ_QUERY,
    query
  };
};

export const clearProps = () => {
  return {
    type: CLEAR_PROPS_FOR_QUOTATION,
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_TPWQ_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_TPWQ_SUCCESS,
    data
  };
};

export const setValueForTotalSpare = (data) => {
  return {
    type: STORE_TOTAL_DATA_FOR_SPARE,
    data
  };
};

export const setValueForTotalLabour = (data) => {
  return {
    type: STORE_TOTAL_DATA_FOR_LABOUR,
    data
  };
};

export const fetchTpwResourceSuccess = (data) => {
  return {
    type: FETCH_TPW_NO_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const {thirdPartyWorkQuotation} = store.getState();
      const {query} = thirdPartyWorkQuotation;
      const response = await axios.get(`/third-party-work-quotation?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {thirdPartyWorkQuotation} = store.getState();
      const {query} = thirdPartyWorkQuotation;
      const response = await axios.get(`/third-party-work-quotation/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      let formData = new FormData();
      const documentData = [];
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data);
      });
      formData.append('documentData', JSON.stringify(documentData));
      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return
        }
        if (key === 'spareRequired') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        if (key === 'labourRequired') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        if (payload[key] !== null) {
          formData.append(key, payload[key]);
        }
      });

      const response = await axios.post(`/third-party-work-quotation`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});

      dispatch(fetchSuccess());
      dispatch(createResourceSuccess(response.data));
      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/third-party-work-quotation');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/third-party-work-quotation/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchTpwNo = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    let query = '';
    Object.entries(data).forEach(([key, value], index) => {
      if(Object.keys(data).length - 1 === index) {
        query += `${key}=${value}`
      } else {
        query += `${key}=${value}&`
      }
    });
    try {
      const response = await axios.get(`/third-party-work-quotation/tpw?${query}`);
      dispatch(fetchSuccess());
      dispatch(fetchTpwResourceSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};
